export const MIN_COMPARE_ITEMS = 2;
export const MAX_COMPARE_ITEMS = 4;

export const specsToCompare = {
  性能: [
    { key: 'cruise_speed', label: '巡航速度', unit: '公里/小时' },
    { key: 'max_range', label: '最大航程', unit: '公里' },
    { key: 'max_passengers', label: '最大载客量', unit: '人' },
    { key: 'engine', label: '发动机' },
    { key: 'thrust', label: '推力', unit: '千牛' },
  ],
  尺寸: [
    { key: 'length', label: '长度', unit: '米' },
    { key: 'wingspan', label: '翼展', unit: '米' },
    { key: 'height', label: '高度', unit: '米' },
    { key: 'production_count', label: '生产数量', unit: '架' },
  ],
  '客舱与运营': [
    { key: 'cabin_width', label: '客舱宽度', unit: '米' },
    { key: 'cabin_height', label: '客舱高度', unit: '米' },
    { key: 'cabin_noise_level', label: '客舱噪声' },
    { key: 'pressurization_altitude', label: '客舱增压高度' },
    { key: 'cargo_capacity', label: '货舱容量', unit: '立方米' },
  ],
};

export const summarySpecsToCompare = [
  { key: 'max_range', label: '最大航程', unit: '公里' },
  { key: 'cruise_speed', label: '巡航速度', unit: '公里/小时' },
  { key: 'max_passengers', label: '最大载客量', unit: '人' },
  { key: 'wingspan', label: '翼展', unit: '米' },
  { key: 'cabin_width', label: '客舱宽度', unit: '米' },
  { key: 'cargo_capacity', label: '货舱容量', unit: '立方米' },
];

const toNumericId = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const parseComparisonIds = (value) => {
  if (!value) return [];

  return String(value)
    .split(',')
    .map(toNumericId)
    .filter(Boolean);
};

export const arePlaneIdListsEqual = (left = [], right = []) => {
  if (left.length !== right.length) {
    return false;
  }

  return left.every((planeId, index) => planeId === right[index]);
};

export const normalizeComparisonIds = (
  ids,
  allPlanes,
  minCount = MIN_COMPARE_ITEMS
) => {
  if (!Array.isArray(allPlanes) || allPlanes.length === 0) {
    return [];
  }

  const availableIds = new Set(allPlanes.map((plane) => plane.id));
  const normalizedIds = [];

  (Array.isArray(ids) ? ids : []).forEach((value) => {
    const planeId = toNumericId(value);
    if (!planeId || !availableIds.has(planeId) || normalizedIds.includes(planeId)) {
      return;
    }
    if (normalizedIds.length >= MAX_COMPARE_ITEMS) {
      return;
    }
    normalizedIds.push(planeId);
  });

  const targetCount = Math.min(Math.max(minCount, 1), allPlanes.length, MAX_COMPARE_ITEMS);

  allPlanes.forEach((plane) => {
    if (normalizedIds.length >= targetCount) {
      return;
    }
    if (!normalizedIds.includes(plane.id)) {
      normalizedIds.push(plane.id);
    }
  });

  return normalizedIds.slice(0, Math.min(MAX_COMPARE_ITEMS, allPlanes.length));
};
